module.exports = __webpack_public_path__ + "img/user.9072cf5f.svg";